function isMobileDevice() {
  return window.matchMedia("(max-width: 767px)").matches;
}

function customZoomForMobileDevice() {  
  if (isMobileDevice()) {
    // Finding the div with the class 'pswp__zoom-wrap'
    let zoomEelements = document.querySelectorAll('.pswp__zoom-wrap');
    console.log(zoomEelements);
    console.log(zoomEelements.length);
    
    for (let i = 0; i < zoomEelements.length; i++) {
      zoomEelements[i].classList.add('mob-device-default-zoom');
      
      setTimeout(function() {
        console.log("Initializing class removal script");
        var proZoomButtonImgs = zoomEelements[i].querySelectorAll('.pswp__img:not(.pswp__img--placeholder)');
        //var proZoomButtonImgs = zoomEelements[i].querySelectorAll('.pswp__img');
        console.log(proZoomButtonImgs);
        console.log("Number of relevant images: ", proZoomButtonImgs.length);
        
        proZoomButtonImgs.forEach(function(proZoomButtonImg) {
          console.log(proZoomButtonImg);
          proZoomButtonImg.addEventListener('touchmove', function(e) {            
            // Getting the parent node
            let parentDiv = this.parentNode;         
            console.log("Parent div: ", parentDiv);
            
            if (parentDiv && parentDiv.classList.contains('mob-device-default-zoom')) {
              console.log("Removing 'mob-device-default-zoom' class");
              parentDiv.classList.remove('mob-device-default-zoom');
            }
          });
        });
      }, 700);
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {  
  var radioButtons = document.querySelectorAll('.variant-input-wrap-parent-event input[type=radio]');
  // for all color radio button event
  radioButtons.forEach(function(radioButton) {
    radioButton.addEventListener('change', function() {
      if (radioButton.checked) {
        var colorSelection = this.value;
        var proVariantImgList = document.querySelectorAll('div.product-variant-image-data-item');
        var selectValueImgArr = [];
        var selectValueImgIdxArr = [];

        //arrange image list 
        proVariantImgList.forEach(function(proVariantImg) {
          var selectValueArr = proVariantImg.getAttribute("data-variant-option-name").split(",");
          var selectValueImg = proVariantImg.getAttribute("data-variant-option-img");
          selectValueArr.forEach(function(selectValue) {
            if(colorSelection == selectValue){
              selectValueImgArr.push(proVariantImg.getAttribute("data-variant-option-img"));
            }
          });
        });
        console.log(selectValueImgArr);

        //select image change radio button
        var childRadioButtons = document.querySelectorAll('.variant-input-wrap-child-event input[type=radio]');
        childRadioButtons.forEach(function(childRadioButton, idx) {
          childRadioButton.nextElementSibling.style = "background: url('"+selectValueImgArr[idx]+"');background-color: unset; background-repeat: no-repeat; background-size: contain;"
        });
      }
    });
  });
  
  //if alredy select color
  radioButtons.forEach(function(radioButton) {
    if (radioButton.checked) {
      var event = new Event('change');
      radioButton.dispatchEvent(event);
    }
  });

/*
  // Replace with the path or URL of the new image
  let imageSrc = "//fdfurniture.ca/cdn/shop/t/33/assets/sketch_jpg.png?v=74777308678871855671689010554";
  let sliderElmLen = document.querySelectorAll(".product-slideshow .product-main-slide").length;
  let sliderElmTran = sliderElmLen * 100;  
  let gallerySelectedItem = document.querySelector(".product-slideshow .product-main-slide:last-child"); // Select the second item
  let galleryTransformValue = gallerySelectedItem.style.transform || gallerySelectedItem.style.webkitTransform;
  let galleryTranslateXValue = 0;
  
  if (galleryTransformValue && galleryTransformValue !== "none") {
    let matches = galleryTransformValue.match(/translateX\(([-\d.]+)%\)/);
    console.log(matches);
    if (matches && matches.length > 1) {
      galleryTranslateXValue = parseFloat(matches[1]);
    }
  }
  galleryTranslateXValue = +galleryTranslateXValue + 100;
  console.log("translateX value:", galleryTranslateXValue);

  
  let sketchDivGallery = '<div class="fd-orientation-sketch-gallery product-main-slide secondary-slide is-selected" data-index="'+sliderElmLen+'" style="position: absolute; left: 0px; transform: translateX('+galleryTranslateXValue+'%);" tabindex="0">';
  sketchDivGallery += '<div data-product-image-main="" class="product-image-main" data-size="square">';
  sketchDivGallery += '<div class="image-wrap loaded" style="height: 0; padding-bottom: 66.6851903306474%;">';
  sketchDivGallery += '<image-element data-aos="image-fade-in" class="aos-init aos-animate">';
  sketchDivGallery += '<img src="'+imageSrc+'&amp;width=1080" width="" height="" class="photoswipe__image image-element" loading="eager" alt="Joelle Feather Blend Sectional" srcset="'+imageSrc+'&amp;width=360 360w,'+imageSrc+'&amp;width=540  540w,'+imageSrc+'&amp;width=720  720w,'+imageSrc+'&amp;width=900  900w,'+imageSrc+'&amp;width=1080  1080w," data-photoswipe-src="'+imageSrc+'&amp;width=1800" data-photoswipe-width="3599" data-photoswipe-height="2400" data-index="13" sizes="(min-width: 769px) 60vw, 75vw">';
  sketchDivGallery += '</image-element>';
  //sketchDivGallery += '<button type="button" class="btn btn--secondary btn--circle js-photoswipe__zoom product__photo-zoom" aria-label="Zoom">';
  //sketchDivGallery += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-search" viewBox="0 0 64 64">';
  //sketchDivGallery += '<path d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58ZM54 54 41.94 42" style="fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px"></path>';
  //sketchDivGallery += '</svg>';
  //sketchDivGallery += '</button>';
  sketchDivGallery += '</div>';
  sketchDivGallery += '</div>';
  sketchDivGallery += '</div>';
  if (isMobileDevice()) {
    // Code to run if the device is a mobile device
    console.log("Mobile device detected");
    galleryTranslateXValue = parseFloat((galleryTranslateXValue - (galleryTranslateXValue * 26 /100))).toFixed(2); 
  }

  let sketchImgClick = document.querySelector('.fd-orientation-sketch');
  sketchImgClick.addEventListener('click', function() {
    let sliderElm = document.querySelector(".product-slideshow .flickity-slider");
    let sketchDivGalleryExist = document.querySelector(".fd-orientation-sketch-gallery");
    console.log(sketchDivGalleryExist);
    if(!sketchDivGalleryExist){
      sliderElm.style.left = "0px";
      sliderElm.style.transform = "translateX(-" + galleryTranslateXValue + "%)";
      console.log(sliderElm);
      sliderElm.insertAdjacentHTML('beforeend', sketchDivGallery);
    }
  });

  let galleryThumImgs = document.querySelectorAll('.product__thumbs--scroller, .variant-input label, .flickity-viewport, .flickity-page-dots');
  galleryThumImgs.forEach(function(galleryThumImg){
    galleryThumImg.addEventListener('click', function() {
      console.log("galleryThumImg");
      let sliderElm = document.querySelector(".flickity-slider");
      let sketchToRemove = document.querySelector('.fd-orientation-sketch-gallery');
      
      if(sketchToRemove)
        sketchToRemove.remove();
    });
  });

  
  if (isMobileDevice()) {
  
  }
    let galleryThumImgs = document.querySelectorAll('.flickity-viewport');
    galleryThumImgs.forEach(function(galleryThumImg){
      galleryThumImg.addEventListener('touchmove', function() {
        console.log("galleryThumImg");
        let sliderElm = document.querySelector(".flickity-slider");
        let sketchToRemove = document.querySelector('.fd-orientation-sketch-gallery');
        
        if(sketchToRemove)
          sketchToRemove.remove();
      });
    });
  }

*/
  

  /*if (isMobileDevice()) {
    // Getting the button by its class
    console.log(document.getElementsByClassName('fd-product-zoom-btn'));
    let proZoomButton = document.getElementsByClassName('fd-product-zoom-btn');

    for (let p = 0; p < proZoomButton.length; p++) {
      // Adding a click event listener to the button
      proZoomButton[p].addEventListener('click', function() {
        customZoomForMobileDevice();
        //setTimeout(customZoomForMobileDevice, 200);
      });
    }

    let proZoomLeftButton = document.getElementsByClassName('pswp__button--arrow--left');
    for (let p = 0; p < proZoomLeftButton.length; p++) {
      // Adding a click event listener to the button
      proZoomLeftButton[p].addEventListener('click', function() {
        customZoomForMobileDevice();
      });
    }

    let proZoomRightButton = document.getElementsByClassName('pswp__button--arrow--right');
    for (let p = 0; p < proZoomRightButton.length; p++) {
      // Adding a click event listener to the button
      proZoomRightButton[p].addEventListener('click', function() {
        customZoomForMobileDevice();
      });
    }
  }*/

  Fancybox.bind('[data-fancybox="fd-fancy-gallery"]', {});
  if (isMobileDevice()) {
    let proZoomButton = document.getElementsByClassName('fd-product-zoom-btn');
    console.log(proZoomButton);
    for (let p = 0; p < proZoomButton.length; p++) {
      proZoomButton[p].classList.remove('hide');
      proZoomButton[p].addEventListener('click', function() {
        console.log("proZoomButton");
        let parentDiv = this.parentNode;
        let imgElements = parentDiv.querySelectorAll("img.image-element");
        imgElements.forEach(function(imgElement) {
          console.log("imgElement");
          imgElement.click();
        });
      });
    }
  } else {
    
  }
});






